import { Banner } from '@repo/foundations';
import type { CreatePolicyStore } from './CreatePolicyStore';

function PiiClassifierBanner({
	store,
	onDismiss,
}: {
	store: CreatePolicyStore;
	onDismiss: () => void;
}) {
	const { piiClassifierBannerTitle, piiClassifierBannerMessage } = store;
	return (
		<Banner
			tone="info"
			title={`Template tip: ${piiClassifierBannerTitle}`}
			message={piiClassifierBannerMessage}
			onDismiss={onDismiss}
			inCard
			weight="bold"
		/>
	);
}

PiiClassifierBanner.displayName = 'PiiClassifierBanner';
export default PiiClassifierBanner;
